module.exports = __webpack_public_path__ + "assets/img/28_975_big.70de9d8a.jpg";